import { useEffect, useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';

import DrawerMenu from '../Navigation/DrawerMenu';
import MainMenu from '../Navigation/MainMenu';
import Logo from './Logo';
import UserMenu from './UserMenu';

import { StyledAppBar, StyledDivider } from './styles';

export default function Header() {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    setDrawerOpen(false);
  }, [location]);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const smDownHidden = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('md'),
  );

  return (
    <StyledAppBar
      position='relative'
      showBurgerMenu
      onClickMenu={handleDrawerToggle}
      brandLogo={<Logo />}
    >
      {smDownHidden ? (
        <DrawerMenu
          drawerOpen={drawerOpen}
          handleDrawerToggle={handleDrawerToggle}
        />
      ) : (
        <>
          <StyledDivider orientation='vertical' flexItem></StyledDivider>

          <MainMenu />
          <Grid container item xs justifyContent='flex-end'>
            <UserMenu />
          </Grid>
        </>
      )}
    </StyledAppBar>
  );
}
